import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useContratosListaFilters
 */

type State = {
    idsCliente?: number[]
    idsCentroCusto?: number[]
    status?: number[]
    dataInicioDe?: Date | null;
    dataInicioAte?: Date | null;
    descricao?: string | null;
    codigo?: number | null;
    dataReceberDe?: Date | null;
    dataReceberAte?: Date | null;

};

type Action = {
    setFilters: (filters: Partial<State>) => void;
    clearFilters: () => void;
};

export const useFinanceiroContratosListaFilters = create<State & Action>((set) => ({
    idsCliente: [],
    idsCentroCusto: [],
    status: [],
    dataInicioDe: null,
    dataInicioAte: null,
    descricao: null,
    codigo: null,
    dataReceberDe: null,
    dataReceberAte: null,
    setFilters: (filters) => set((state) => ({ ...state, ...filters })),
    clearFilters: () => set({ ...initialFinanceiroContratosFiltersValues }),

}));

export const initialFinanceiroContratosFiltersValues: State = {
    idsCliente: [],
    idsCentroCusto: [],
    descricao: null,
    codigo: null,
    status: [0, 2],
    dataInicioDe: null,
    dataInicioAte: null,
    dataReceberDe: null,
    dataReceberAte: null,

};